import { kanbify } from '../lib/kanbifyClient'

export async function claimGeneralTask(cardId) {
    const { data, error } = await kanbify.rpc('claim_general_task', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

export async function unclaimGeneralTask(cardId) {
    const { data, error } = await kanbify.rpc('unclaim_general_task', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Claim a procedure card you're not assigned to (additive self-join → shows in Acasă). */
export async function claimProcedure(cardId) {
    const { data, error } = await kanbify.rpc('claim_procedure', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Undo claimProcedure — leave a procedure card you picked up. */
export async function leaveProcedure(cardId) {
    const { data, error } = await kanbify.rpc('leave_procedure', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** "Prelua azi" — ensure today's card for a procedure exists + join it. */
export async function claimProcedureToday(procedureId) {
    const { data, error } = await kanbify.rpc('claim_procedure_today', { p_procedure_id: procedureId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Undo "Fac eu azi" — remove self from today's card of this procedure. */
export async function unclaimProcedureToday(procedureId) {
    const { data, error } = await kanbify.rpc('unclaim_procedure_today', { p_procedure_id: procedureId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Toggle "primesc mereu" — add/remove self from a procedure's default assignees. */
export async function setProcedureAlways(procedureId, enabled) {
    const { data, error } = await kanbify.rpc('set_procedure_always', { p_procedure_id: procedureId, p_enabled: enabled })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Step KPI progress: toggle a procedure step done/undone with a quantity ("de câte ori"). Awards/subtracts points. */
export async function setStepProgress(itemId, done, quantity = 1) {
    const { data, error } = await kanbify.rpc('set_step_progress', { p_item_id: itemId, p_done: done, p_quantity: quantity })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

/** Award the single completion bonus when a procedure card is finalized (idempotent). */
export async function awardProcedureBonus(cardId) {
    const { data, error } = await kanbify.rpc('award_procedure_bonus', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

export async function startTimerWithValidation(cardId) {
    const { data, error } = await kanbify.rpc('start_timer_with_validation', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

export async function resumePausedCard(cardId) {
    const { data, error } = await kanbify.rpc('resume_paused_card', { p_card_id: cardId })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

export async function launchPriorityProcedure(procedureId, assigneeIds) {
    const { data, error } = await kanbify.rpc('launch_priority_procedure', {
        p_procedure_id: procedureId,
        p_assignee_ids: assigneeIds,
    })
    if (error) return { success: false, error: error.message }
    return data || { success: false, error: 'No response' }
}

export async function checkCardTriggers(cardId) {
    const { data, error } = await kanbify.rpc('card_has_unmet_triggers', { p_card_id: cardId })
    if (error) return { blockers: [], error: error.message }
    return { blockers: data || [], error: null }
}

/** Custom list CRUD — standalone functions.
 *  No separate hook: Dashboard reads `dash.userCustomLists` (already fetched in
 *  the LIVE-mode batch) so we avoid a duplicate user_custom_lists query.
 *  Mutations refetch the dashboard via dash.refetch() in the caller. */
export async function addCustomList(userId, name, color = null, position = 0) {
    const { data, error } = await kanbify
        .from('user_custom_lists')
        .insert([{ user_id: userId, name, color, position }])
        .select()
        .single()
    if (error) return { success: false, error: error.message }
    return { success: true, data }
}

export async function renameCustomList(id, name) {
    const { error } = await kanbify.from('user_custom_lists').update({ name }).eq('id', id)
    if (error) return { success: false, error: error.message }
    return { success: true }
}

export async function removeCustomList(id) {
    const { error } = await kanbify.from('user_custom_lists').delete().eq('id', id)
    if (error) return { success: false, error: error.message }
    return { success: true }
}
